import { useEffect } from 'react'
import * as C from './styles.js'
import { Link } from 'react-router-dom'
import { useState } from 'react';

export default function Suggestions({ movie, all_movies }) {

  const [ movies, setMovies ] = useState();

  useEffect(() => {
    if (all_movies?.movies?.length > 0 && movie?.tags?.length > 0) {
      const tagsToIgnore = [ 47, 48, 49, 50 ];
      const exceptionTags = [ 8, 10, 18, 20, 21, 26, 28, 35, 41, 46, 52, 53, 54, 55, 56 ]; // Tags que podem ser pesquisadas individualmente
  
      // Filtrar tags válidas do filme principal
      const validMovieTags = movie.tags.filter((tag) => !tagsToIgnore.includes(tag));
  
      const moviesFiltered = all_movies.movies
        .filter((movieItem) => {
          // Excluir o próprio filme
          if (movieItem.id_tmdb === movie.id_tmdb) return false;
  
          // Filtrar tags válidas do filme atual
          const validTags = movieItem.tags.filter((tag) => !tagsToIgnore.includes(tag));
          if (validTags.length === 0) return false; // Ignorar filmes com todas as tags em `tagsToIgnore`
  
          // Calcular tags em comum, considerando apenas tags válidas
          const commonTags = validTags.filter((tag) => validMovieTags.includes(tag));
  
          // Regras para filmes com base no número de tags
          if (validMovieTags.length === 1) {
            // Filme principal tem apenas 1 tag válida
            return (
              commonTags.length === 1 || // Deve ter exatamente 1 tag em comum
              commonTags.some((tag) => exceptionTags.includes(tag)) // Ou a tag em comum é uma exceção
            );
          } else {
            // Filme principal tem mais de 1 tag válida
            return (
              commonTags.length >= 2 || // Deve ter pelo menos 2 tags em comum
              commonTags.some((tag) => exceptionTags.includes(tag)) // Ou a tag em comum é uma exceção
            );
          }
        })
        .map((movieItem) => {
          // Recalcular tags em comum para adicionar ao objeto
          const validTags = movieItem.tags.filter((tag) => !tagsToIgnore.includes(tag));
          const commonTags = validTags.filter((tag) => validMovieTags.includes(tag));
  
          return {
            ...movieItem,
            common_tags: commonTags, // Tags em comum
            common_tags_count: commonTags.length, // Número de tags em comum
            is_exact_match:
              commonTags.length === validMovieTags.length &&
              validMovieTags.length === validTags.length, // Tags idênticas
          };
        })
        .sort((a, b) => {
          // Priorizar filmes com tags idênticas (isExactMatch)
          if (a.is_exact_match && !b.is_exact_match) return -1;
          if (!a.is_exact_match && b.is_exact_match) return 1;
  
          // Priorizar filmes com mais tags em comum
          return b.common_tags_count - a.common_tags_count;
        })
        .slice(0, 20); // Limitar a 20 filmes
  
      setMovies(moviesFiltered);
    }
  }, [movie, all_movies]);      
    
  const converter = (minutos) => {
    const horas = Math.floor(minutos/ 60);
    const min = minutos % 60;
    const textoHoras = (`${horas}`);
    const textoMinutos = (`${min}`);

    if (minutos <= 59) {
        return `${textoMinutos}min`;
    } else if (minutos == 60) {
        return `${textoHoras }h`;
    } else if (minutos >= 61) {
        return `${textoHoras }h, ${textoMinutos}min`;
    }
  };

  return (
    <C.Container layoutStyle={'grid'}>
      {(!movie?.movie_collection_id && !movie?.movie_subcollection_id) && 
          <header>
              <h2>Sugestões</h2>
          </header>
      }
      <div className='container-movies'>
          {movies?.map((movie_suggestion, index) => {

            const isDisabled = movie?.id_tmdb == movie_suggestion?.id_tmdb;

            // exclui o filme atual das sugestões
            if (movie_suggestion?.id_imdb == movie?.id_imdb) {
                return;
            } 

            return (
              <Link isDisabled={isDisabled} className='movie' to={`/details/${movie_suggestion.media_type}/${movie_suggestion?.id_tmdb}/${movie_suggestion?.id_imdb}`} key={index}>
                <div className='container-image'>
                  <img src={`https://image.tmdb.org/t/p/w400${movie_suggestion?.backdrop_path}`} alt={`imagem do filme ${movie_suggestion?.name}`} />
                </div>
                <div className='details'>
                  <h2 title={movie_suggestion?.name} className='name'>{/*index + 1*/} {movie_suggestion?.name}</h2>
                  <section>
                      {movie_suggestion?.more_details?.vote_average > 0 && <span><i className='fas fa-star'></i> {movie_suggestion?.more_details?.vote_average.toFixed(1)}</span>}
                      {movie_suggestion?.more_details?.release_date && <span><i className="fas fa-calendar"></i> {(movie_suggestion?.more_details?.release_date).slice(0,4)}</span>}
                      {movie_suggestion?.more_details?.runtime > 0 && <span><i className="fas fa-clock"></i> {converter(movie_suggestion?.more_details?.runtime)}</span>}
                  </section>
                  <p className='overview'>{movie_suggestion?.overview}</p>
                </div>
              </Link>
            )
          })}
        </div>
        {!movies?.length > 0 &&
          <div className='no-suggestions'>
              <p>Não há sugestões disponíveis no momento.</p>
          </div>
        }
    </C.Container>
  );
}